import { render } from "./ProposalPendingPage.vue?vue&type=template&id=bd47aff8"
import script from "./ProposalPendingPage.vue?vue&type=script&lang=js"
export * from "./ProposalPendingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__